module.exports = __webpack_public_path__ + "img/asteroidsVue.6e238f1f.png";